import { isMobile } from 'react-device-detect';
import { useMediaQuery } from '@mui/material';
/**
 * Detect landscape mobile devices.
 * Hacky, but should work for modern mobile devices and browsers.
 * @returns true if the user's device is a mobile device in landscape mode
 */
export function useIsLandscapeMobileViewport() {
  const isLandscape = useMediaQuery('(orientation: landscape)');

  // Simply check if it's a mobile device AND in landscape
  return isMobile && isLandscape;
}
